import { useQuery, UseQueryResult } from 'react-query'
import { ClientConfig, fetchClientConfig } from 'api/config'

// Client feature flags (e.g. POLi on/off). Cached for the session; the consumer
// decides the default while data is loading/unavailable.
export function useClientConfig(): UseQueryResult<ClientConfig> {
  return useQuery(['client-config'], fetchClientConfig, {
    staleTime: 5 * 60_000,
    retry: 1
  })
}
